module.exports = AgoraRTM;


//////////////////
// WEBPACK FOOTER
// external "AgoraRTM"
// module id = +gCL
// module chunks = 28